import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';

import { initialState } from './translation.state';
import { translationAdapterMethodsFactory } from './translation.adapter-methods';
import { translationFeatureMethodsFactory } from './translation.feature-methods';
import { translationHooksFactory } from './translation.hooks';

export const TranslationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(translationAdapterMethodsFactory),
  withMethods(translationFeatureMethodsFactory),
  withHooks(translationHooksFactory),
);
